import { HttpHeaders } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { AppApis } from "@app/core/APIs/app-apis";
import { CrudApiOptions, CrudApiService, GenResp } from "@template-ui/services/crud-api.service";
import { catchError, map, Observable, of } from "rxjs";
import {
  ProgramPackResolutionRequest,
  ProgramPackResolutionResult,
  ProgramPackWorkspaceResult,
  toProgramPackFailure,
  toProgramPackSuccess,
} from "./platform-program-pack-workspace.models";

const requestHeaders = new HttpHeaders({
  Accept: "application/json, text/plain, */*",
  "skip-error-interceptor": "yes",
  "skip-loading-interceptor": "yes",
});

export const platformProgramPackWorkspaceApiOptions: Partial<CrudApiOptions<"body", "json">> = {
  retries: 0,
  feedbackOptions: {
    successMode: "none",
    errorMode: "none",
  },
  getOptions: {
    responseType: "json",
    headers: requestHeaders,
    withCredentials: true,
  },
};

@Injectable({ providedIn: "root" })
export class PlatformProgramPackWorkspaceService {
  private readonly apis = inject(AppApis);
  private readonly crudService = inject(CrudApiService);

  resolvePack(
    request: ProgramPackResolutionRequest,
  ): Observable<ProgramPackWorkspaceResult<ProgramPackResolutionResult>> {
    return this.crudService
      .getbyUrl<ProgramPackResolutionResult>(
        this.apis.core.manual.getPlatformConfigurationPackResolution(request.configurationCode, toPackQuery(request)),
        platformProgramPackWorkspaceApiOptions,
      )
      .pipe(
        map((response) => toProgramPackSuccess(unwrapResponse(response))),
        catchError((error: unknown) => of(toProgramPackFailure<ProgramPackResolutionResult>(error))),
      );
  }
}

function toPackQuery(request: ProgramPackResolutionRequest): Omit<ProgramPackResolutionRequest, "configurationCode"> {
  return {
    jurisdictionCode: request.jurisdictionCode,
    programCode: request.programCode,
    asOfUtc: request.asOfUtc,
  };
}

function unwrapResponse<T>(response: GenResp<T> | T | undefined | null): T {
  if (response && typeof response === "object" && "data" in response) {
    return (response as GenResp<T>).data;
  }

  return response as T;
}
